import type { NsiteProvider } from '@/contexts/DeploySettingsContext';
import type { PresetDeployProvider } from './deploy/types';

/** Default nsite provider configuration, pre-configured for new users. */
export const DEFAULT_NSITE_PROVIDER: NsiteProvider = {
  id: 'nsite',
  name: 'nsite',
  type: 'nsite',
  gateway: 'shakespeare.to',
  relayUrls: [
    'wss://relay.ditto.pub',
    'wss://relay.dreamith.to',
    'wss://relay.nsite.lol',
    'wss://relay.nosto.re',
    'wss://relay.primal.net',
  ],
  blossomServers: [
    'https://blossom.ditto.pub',
    'https://blossom.dreamith.to',
    'https://blossom.primal.net',
    'https://cdn.sovbit.host',
  ],
};

export const PRESET_DEPLOY_PROVIDERS: PresetDeployProvider[] = [
  {
    id: 'shakespeare',
    type: 'shakespeare',
    name: 'Shakespeare Deploy',
    description: 'Deploy to Shakespeare hosting with Nostr authentication',
    baseURL: 'https://shakespeare.diy',
    requiresNostr: true,
  },
  {
    id: 'nsite',
    type: 'nsite',
    name: 'nsite',
    description: 'Deploy to Nostr as a static website',
    // No baseURL for nsite - uses Rocket icon fallback
  },
  {
    id: 'netlify',
    type: 'netlify',
    name: 'Netlify',
    description: 'Deploy to Netlify',
    baseURL: 'https://api.netlify.com/api/v1',
    apiKeyLabel: 'Personal Access Token',
    apiKeyURL: 'https://app.netlify.com/user/applications#personal-access-tokens',
    proxy: true,
  },
  {
    id: 'vercel',
    type: 'vercel',
    name: 'Vercel',
    description: 'Deploy to Vercel',
    baseURL: 'https://api.vercel.com',
    apiKeyLabel: 'Access Token',
    apiKeyURL: 'https://vercel.com/account/tokens',
    proxy: true,
  },
  {
    id: 'cloudflare',
    type: 'cloudflare',
    name: 'Cloudflare',
    description: 'Deploy to Cloudflare Workers',
    baseURL: 'https://api.cloudflare.com/client/v4',
    apiKeyLabel: 'API Token',
    apiKeyURL: 'https://dash.cloudflare.com/profile/api-tokens',
    accountIdLabel: 'Account ID',
    accountIdURL: 'https://developers.cloudflare.com/fundamentals/account/find-account-and-zone-ids/',
    proxy: true,
  },
  {
    id: 'deno',
    type: 'deno',
    name: 'Deno Deploy',
    description: 'Deploy to Deno Deploy',
    baseURL: 'https://api.deno.com/v1',
    apiKeyLabel: 'Access Token',
    apiKeyURL: 'https://dash.deno.com/account#access-tokens',
    organizationIdLabel: 'Organization ID',
    organizationIdURL: 'https://dash.deno.com/orgs',
    proxy: true,
  },
  {
    id: 'railway',
    type: 'railway',
    name: 'Railway',
    description: 'Deploy to Railway',
    baseURL: 'https://backboard.railway.com',
    apiKeyLabel: 'API Token',
    apiKeyURL: 'https://railway.app/account/tokens',
    proxy: true,
  },
];
